import { render, staticRenderFns } from "./CourseProgress.vue?vue&type=template&id=428da3bf&scoped=true&"
import script from "./CourseProgress.vue?vue&type=script&lang=js&"
export * from "./CourseProgress.vue?vue&type=script&lang=js&"
import style0 from "./CourseProgress.vue?vue&type=style&index=0&id=428da3bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428da3bf",
  null
  
)

export default component.exports